import React, { useEffect, useState } from 'react'

import "common/css/master.css";


const ToTeacherTable = (props) => {
    const { lstTeacherAllocation, teacherAllocationId, setTeacherAllocationId } = props;

    const [lstTeacherAllocationFiltered, setLstTeacherAllocationFiltered] = useState([]);
    const [selTeacherAllocationId, setSelTeacherAllocationId] = useState(0);

    useEffect(() => {
        // console.log("useEffect in TeacherAllocationTable component called, lstTeacherAllocation", lstTeacherAllocation);
        setLstTeacherAllocationFiltered(lstTeacherAllocation);
    }, [lstTeacherAllocation]);

    useEffect(() => {
        // console.log("useEffect in TeacherAllocationTable component called teacherAllocationId", teacherAllocationId);
        setSelTeacherAllocationId(teacherAllocationId);
    }, [teacherAllocationId]);

    const colgrp = <colgroup>
    <col width="75"></col>
    <col width="30"></col>
    <col width="32"></col>
    <col width="27"></col>
    <col width="58"></col>
    </colgroup>

    function binaryToDays(binaryString) {
        // console.log("Method called: binaryToDays");
        // console.log("Parameters passed:", { binaryString });

        const daysOfWeek = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
        let result = '';

        for (let i = 0; i < binaryString.length; i++) {
            if (binaryString[i] === '1') {
                result += daysOfWeek[i];
            } else {
                result += "-"
            }
        }

        // console.log("Value to be returned:", result);
        return result;
    }

    return (
        <div >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr>
                            <th >
                                Teacher
                            </th>
                            <th >
                                Available
                            </th>
                            <th >
                                Max. Allocation
                            </th>
                            <th >
                                Days Off
                            </th>
                            <th >
                                Periods Off
                            </th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "50vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="diaryMonthlyTeacherAllocationTable" >
                            {lstTeacherAllocationFiltered &&
                                lstTeacherAllocationFiltered.map((teacherAllocation, i) => (
                                    <tr key={teacherAllocation.teacherAllocationId}
                                        onClick={() => setTeacherAllocationId(teacherAllocation.tchId)}
                                        className={teacherAllocation.tchId === selTeacherAllocationId ? "selected" : ''}>
                                        <td className="text-left">{teacherAllocation.tch}</td>
                                        <td className="text-center">{teacherAllocation.available ?
                                            <span
                                                style={{ color: "green" }}
                                                className='glyphicon glyphicon-ok'
                                            ></span>
                                            :
                                            <span
                                                className='glyphicon glyphicon-remove'
                                            ></span>
                                        }</td>
                                        <td className="text-center">{teacherAllocation.maxAlloc}</td>
                                        <td className="text-center">{binaryToDays(teacherAllocation.daysOff)}</td>
                                        <td className="text-center">{teacherAllocation.periodsOff}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default ToTeacherTable;